import React, { useRef } from 'react'
import { MdOutlineClose } from 'react-icons/md'
import useClickOutside from '../../hooks/useClickOutside';

type TDialogLayout = {
    onClose: () => void;
    children: React.ReactNode;
    bgColor?: string;
}

const DialogLayout = ({ onClose, children, bgColor = 'bg-system-light-60' }: TDialogLayout) => {
    const dialogLayoutRef = useRef<HTMLDivElement>(null);

    useClickOutside(dialogLayoutRef, onClose);

    return (
        <div className="container-dialog fixed top-0 left-0 w-full h-full" >
            <div
                className={`container-inner shadow-custom-dual ${bgColor} max-h-[calc(100vh-2rem)] w-[386px] sm:w-auto`}
                ref={dialogLayoutRef}
            >
                <div className='flex flex-col max-h-[calc(100vh-2rem)]'>
                    <div className="flex justify-end sticky top-0 bg-inherit px-6 pt-6">
                        <button onClick={onClose} className="flex w-full justify-end sticky top-0">
                            <MdOutlineClose size={24} />
                        </button>
                    </div>
                    <div className='flex-1 overflow-y-auto px-6 pb-6'>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DialogLayout